// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class ExternalIdRequestModel {
    'accountId': number;
    'externalId': string;
    'externalIdType': ExternalIdRequestModel.ExternalIdTypeEnum;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ExternalIdRequestModel>> = [
        {
            "name":     "accountId",
            "baseName": "accountId",
            "type":     "number"
        },
        {
            "name":     "externalId",
            "baseName": "externalId",
            "type":     "string"
        },
        {
            "name":     "externalIdType",
            "baseName": "externalIdType",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return ExternalIdRequestModel.attributeTypeMap;
    }
}
export namespace ExternalIdRequestModel {
    export enum ExternalIdTypeEnum {
        Unkn = 'UNKN',
        UbcHubId = 'UbcHubId',
        MemberNumber = 'MemberNumber',
        Adlds = 'ADLDS',
        ThirdPartyId = 'ThirdPartyId',
        ArxId = 'ARxId',
        CarePathId = 'CarePathId',
        VmiPatientId = 'VmiPatientId',
        PorticoPortalId = 'PorticoPortalId',
        SiteAccountId = 'SiteAccountId',
        PatientMckId = 'PatientMckId',
        RemsId = 'RemsId',
        MangoActivationId = 'MangoActivationId',
        PatientPartnerId = 'PatientPartnerId',
        PartnerPatientId = 'PartnerPatientId',
        SunovionId = 'SunovionID',
        PharmaCordPatientId = 'PharmaCordPatientId',
        IBondId = 'IBondId',
        IBondEnrollmentId = 'IBondEnrollmentId',
        InfinitusId = 'InfinitusId',
        EvinceMedId = 'EvinceMedId',
        SubjectId = 'SubjectId',
        CmmCaseKey = 'CmmCaseKey',
        UniversalHubId = 'UniversalHubId'
    }
}
